import React from 'react'
import delve from 'dlv'
import parse, { domToReact, Element } from 'html-react-parser'
import { replaceUrls } from 'lib/templates'
import { getMediaUrl, getMediaAlt } from 'lib/model'
import { getBlock } from 'lib/model'

interface Props {
  content: any
  global: any
  showPopupStorefront(): void
}

const replaceOnClick = (content: string, onClick: () => void) => {
  return parse(content, {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.attribs) {
        if (domNode.attribs.id === 'showPopup') {
          return (
            <a role="button" onClick={onClick}>
              {domToReact(domNode.children)}
            </a>
          )
        }
      }
    },
  })
}

const FastSpringCheckoutPage: React.FC<Props> = ({
  content,
  global,
  showPopupStorefront,
}) => {
  const { blocks } = delve(content, 'data.attributes')
  const block = getBlock(blocks, 'blocks.fast-spring-popup-checkout')
  const { title, text, copyright, header } = block
  const { logo, supportText } = header
  const { links } = global

  return (
    <>
      <div className="header">
        <img src={getMediaUrl(logo)} alt={getMediaAlt(logo)} />
        <h2></h2>
        <div className="header__help">{replaceUrls(supportText, links)}</div>
      </div>
      <section className="checkout-error-section container">
        <h1>{title}</h1>
        {replaceOnClick(text, showPopupStorefront)}
      </section>
      <div className="ftr">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              &copy; {new Date().getFullYear()} {copyright}
            </div>
            <div className="col-md-6" />
          </div>
        </div>
      </div>
    </>
  )
}

export default FastSpringCheckoutPage
